import { render, staticRenderFns } from "./ResponsibleSquadListTable.vue?vue&type=template&id=a07d0a62&"
import script from "./ResponsibleSquadListTable.vue?vue&type=script&lang=js&"
export * from "./ResponsibleSquadListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports